import React from 'react';

import MediaPicker from '../../../components/admin/MediaPicker';

import RichTextField, { RichTextParagraphsField } from './RichTextField';

import {

  BUTTON_VARIANTS,

  ICON_OPTIONS,

  defaultBetaBlock,

  defaultButton,

} from './ctaHelpers';

import OptionGroup from '../pageEditor/OptionGroup';
import { DragHandle, SortableItem, reorder } from '../pageEditor/sortable';



function ButtonStyleFields({ btn, onChange }) {

  const variant = btn.variant || (btn.primary ? 'primary' : 'secondary');

  const style = btn.style || {};



  const updateStyle = (patch) => onChange({ ...btn, style: { ...style, ...patch } });



  return (

    <>

      <div className="admin-grid-2">

        <label>

          Style

          <select

            value={variant}

            onChange={(e) => onChange({ ...btn, variant: e.target.value, primary: e.target.value === 'primary' })}

          >

            {BUTTON_VARIANTS.map((v) => (

              <option key={v.value} value={v.value}>{v.label}</option>

            ))}

          </select>

        </label>

        <label>

          Icon

          <select

            value={btn.icon || ''}

            onChange={(e) => onChange({ ...btn, icon: e.target.value })}

          >

            {ICON_OPTIONS.map((opt) => (

              <option key={opt.value || 'none'} value={opt.value}>{opt.label}</option>

            ))}

          </select>

        </label>

      </div>

      <label>

        Custom icon class

        <input

          value={btn.icon || ''}

          onChange={(e) => onChange({ ...btn, icon: e.target.value })}

          placeholder="fas fa-flask"

        />

      </label>

      <div className="admin-grid-2">

        <label className="admin-checkbox">

          <input

            type="checkbox"

            checked={!!btn.external}

            onChange={(e) => onChange({ ...btn, external: e.target.checked })}

          />

          Open in new tab

        </label>

        <label className="admin-checkbox">

          <input

            type="checkbox"

            checked={!!btn.download}

            onChange={(e) => onChange({ ...btn, download: e.target.checked })}

          />

          Download link

        </label>

      </div>

      <OptionGroup title="Style" defaultOpen={variant === 'custom' || !!(style.background || style.color || style.borderColor)}>

        <div className="tpb-style-grid">

          <label>

            Background

            <input

              type="text"

              value={style.background || ''}

              onChange={(e) => updateStyle({ background: e.target.value })}

              placeholder="#ffd700 or linear-gradient(...)"

            />

          </label>

          <label>

            Text colour

            <input

              type="color"

              value={style.color?.startsWith('#') && style.color.length === 7 ? style.color : '#000000'}

              onChange={(e) => updateStyle({ color: e.target.value })}

            />

          </label>

          <label>

            Border colour

            <input

              type="color"

              value={style.borderColor?.startsWith('#') && style.borderColor.length === 7 ? style.borderColor : '#ffd700'}

              onChange={(e) => updateStyle({ borderColor: e.target.value })}

            />

          </label>

          <label>

            Hover background

            <input

              type="text"

              value={style.hoverBackground || ''}

              onChange={(e) => updateStyle({ hoverBackground: e.target.value })}

              placeholder="Optional hover colour/gradient"

            />

          </label>

        </div>

      </OptionGroup>

      <div className="tpb-button-preview">

        <span className="tpb-rich-preview-label">Button preview</span>

        <div className="tpb-button-preview-inner">

          <span
            className={variant === 'custom' ? 'btn btn-custom' : `btn btn-${variant === 'primary' ? 'primary' : variant}`}
            style={{
              ...(style.background && { '--btn-bg': style.background }),
              ...(style.color && { '--btn-color': style.color }),
              ...(style.borderColor && { '--btn-border': style.borderColor }),
              ...(style.hoverBackground && { '--btn-bg-hover': style.hoverBackground }),
            }}
          >
            {btn.icon && <i className={btn.icon} aria-hidden="true" />}
            {btn.text || 'Button text'}
          </span>

        </div>

      </div>

    </>

  );

}



export function ToolPageSectionFields({ section, onChange }) {

  const update = (patch) => onChange({ ...section, ...patch });



  return (

    <div className="tpb-fields admin-form">

      <OptionGroup title="Content">

      <div className="admin-grid-2">

        <label>

          Heading

          <input value={section.heading || ''} onChange={(e) => update({ heading: e.target.value })} />

        </label>

        <label>

          Highlight

          <input value={section.highlight || ''} onChange={(e) => update({ highlight: e.target.value })} />

        </label>

      </div>



      {section.type === 'description' && (

        <RichTextParagraphsField

          label="Paragraphs"

          paragraphs={section.paragraphs || []}

          rows={5}

          onChange={(paragraphs) => update({ paragraphs })}

        />

      )}



      {section.type === 'video' && (

        <>

          <label>

            YouTube video ID

            <input value={section.youtubeId || ''} onChange={(e) => update({ youtubeId: e.target.value })} placeholder="dQw4w9WgXcQ" />

          </label>

          {section.youtubeId && (

            <div className="tpb-media-preview">

              <img src={`https://img.youtube.com/vi/${section.youtubeId}/mqdefault.jpg`} alt="Video thumbnail" />

            </div>

          )}

          <label>

            iframe title

            <input value={section.title || ''} onChange={(e) => update({ title: e.target.value })} />

          </label>

        </>

      )}



      {section.type === 'steps' && (

        <>

          <RichTextField

            label="Intro"

            value={section.intro || ''}

            rows={2}

            onChange={(intro) => update({ intro })}

          />

          {(section.steps || []).map((step, stIdx) => (

            <SortableItem key={stIdx} listId="steps" index={stIdx} className="tpb-nested-block" onMove={(from, to) => update({ steps: reorder(section.steps, from, to) })}>

              <div className="tpb-nested-block-head">

                <DragHandle listId="steps" index={stIdx} />

                <strong>Step {stIdx + 1}</strong>

                {(section.steps || []).length > 1 && (

                  <button

                    type="button"

                    className="admin-icon-btn danger"

                    title="Remove step"

                    onClick={() => update({ steps: section.steps.filter((_, i) => i !== stIdx) })}

                  >

                    <i className="fas fa-trash" aria-hidden="true" />

                  </button>

                )}

              </div>

              <RichTextField

                label="Title"

                value={step.title || ''}

                rows={2}

                onChange={(title) => {

                  const steps = [...section.steps];

                  steps[stIdx] = { ...step, title };

                  update({ steps });

                }}

              />

              <RichTextParagraphsField

                label="Paragraphs"

                paragraphs={step.paragraphs || []}

                rows={3}

                onChange={(paragraphs) => {

                  const steps = [...section.steps];

                  steps[stIdx] = { ...step, paragraphs };

                  update({ steps });

                }}

              />

              <MediaPicker

                label="Screenshot image"

                value={(step.images?.[0]?.src) || ''}

                onChange={(url) => {

                  const steps = [...section.steps];

                  steps[stIdx] = {

                    ...step,

                    images: url ? [{ src: url, alt: step.title }] : [],

                  };

                  update({ steps });

                }}

                placeholder="/images/my-tool/step1.png"

              />

              {step.images?.[0]?.src && (

                <div className="tpb-media-preview">

                  <img src={step.images[0].src} alt={step.title || `Step ${stIdx + 1}`} />

                </div>

              )}

            </SortableItem>

          ))}

          <button

            type="button"

            className="btn btn-secondary tpb-add-btn"

            onClick={() => update({ steps: [...(section.steps || []), { title: '', paragraphs: [''], images: [] }] })}

          >

            <i className="fas fa-plus" aria-hidden="true" /> Add step

          </button>

        </>

      )}



      {section.type === 'platformVideos' && (

        <>

          <RichTextField

            label="Intro"

            value={section.intro || ''}

            rows={2}

            onChange={(intro) => update({ intro })}

          />

          {(section.platforms || []).map((p, pIdx) => (

            <SortableItem key={pIdx} listId="platforms" index={pIdx} className="tpb-nested-block" onMove={(from, to) => update({ platforms: reorder(section.platforms, from, to) })}>

              <div className="tpb-nested-block-head">

                <DragHandle listId="platforms" index={pIdx} />

                <strong>{p.name || `Platform ${pIdx + 1}`}</strong>

                {(section.platforms || []).length > 1 && (

                  <button

                    type="button"

                    className="admin-icon-btn danger"

                    title="Remove platform"

                    onClick={() => update({ platforms: section.platforms.filter((_, i) => i !== pIdx) })}

                  >

                    <i className="fas fa-trash" aria-hidden="true" />

                  </button>

                )}

              </div>

              <label>

                Name

                <input

                  value={p.name || ''}

                  onChange={(e) => {

                    const platforms = [...section.platforms];

                    platforms[pIdx] = { ...p, name: e.target.value };

                    update({ platforms });

                  }}

                />

              </label>

              <label>

                YouTube ID

                <input

                  value={p.youtubeId || ''}

                  onChange={(e) => {

                    const platforms = [...section.platforms];

                    platforms[pIdx] = { ...p, youtubeId: e.target.value };

                    update({ platforms });

                  }}

                />

              </label>

              <label className="admin-checkbox">

                <input

                  type="checkbox"

                  checked={!!p.comingSoon}

                  onChange={(e) => {

                    const platforms = [...section.platforms];

                    platforms[pIdx] = { ...p, comingSoon: e.target.checked };

                    update({ platforms });

                  }}

                />

                Coming soon

              </label>

            </SortableItem>

          ))}

          <button

            type="button"

            className="btn btn-secondary tpb-add-btn"

            onClick={() => update({

              platforms: [...(section.platforms || []), { name: '', highlight: 'Tutorial', youtubeId: '', comingSoon: false }],

            })}

          >

            <i className="fas fa-plus" aria-hidden="true" /> Add platform

          </button>

        </>

      )}



      {section.type === 'cta' && (

        <OptionGroup title="Buttons">

          <p className="tpb-sidebar-hint">Main buttons appear first. Use the featured beta block below for a highlighted call-to-action.</p>



          {(section.buttons || []).map((btn, bIdx) => (

            <SortableItem key={bIdx} listId="buttons" index={bIdx} className="tpb-nested-block" onMove={(from, to) => update({ buttons: reorder(section.buttons, from, to) })}>

              <div className="tpb-nested-block-head">

                <DragHandle listId="buttons" index={bIdx} />

                <strong>{btn.text || `Button ${bIdx + 1}`}</strong>

                {(section.buttons || []).length > 1 && (

                  <button

                    type="button"

                    className="admin-icon-btn danger"

                    title="Remove button"

                    onClick={() => update({ buttons: section.buttons.filter((_, i) => i !== bIdx) })}

                  >

                    <i className="fas fa-trash" aria-hidden="true" />

                  </button>

                )}

              </div>

              <label>

                Button text

                <input

                  value={btn.text || ''}

                  onChange={(e) => {

                    const buttons = [...section.buttons];

                    buttons[bIdx] = { ...btn, text: e.target.value };

                    update({ buttons });

                  }}

                />

              </label>

              <label>

                Link

                <input

                  value={btn.href || ''}

                  onChange={(e) => {

                    const buttons = [...section.buttons];

                    buttons[bIdx] = { ...btn, href: e.target.value };

                    update({ buttons });

                  }}

                />

              </label>

              <ButtonStyleFields

                btn={btn}

                onChange={(nextBtn) => {

                  const buttons = [...section.buttons];

                  buttons[bIdx] = nextBtn;

                  update({ buttons });

                }}

              />

            </SortableItem>

          ))}

          <button

            type="button"

            className="btn btn-secondary tpb-add-btn"

            onClick={() => update({ buttons: [...(section.buttons || []), defaultButton()] })}

          >

            <i className="fas fa-plus" aria-hidden="true" /> Add button

          </button>



          <div className="tpb-nested-block tpb-nested-block--featured">

            <div className="tpb-nested-block-head">

              <strong>Featured beta / highlight block</strong>

              <label className="admin-checkbox">

                <input

                  type="checkbox"

                  checked={section.beta != null}

                  onChange={(e) => update({ beta: e.target.checked ? (section.beta || defaultBetaBlock()) : null })}

                />

                Enabled

              </label>

            </div>

            {section.beta != null && (

              <>

                <RichTextField

                  label="Description above button"

                  value={section.beta.description || ''}

                  rows={2}

                  onChange={(description) => update({ beta: { ...section.beta, description } })}

                />

                <label>

                  Button text

                  <input

                    value={section.beta.text || ''}

                    onChange={(e) => update({ beta: { ...section.beta, text: e.target.value } })}

                  />

                </label>

                <label>

                  Link

                  <input

                    value={section.beta.href || ''}

                    onChange={(e) => update({ beta: { ...section.beta, href: e.target.value } })}

                  />

                </label>

                <ButtonStyleFields

                  btn={{

                    ...defaultBetaBlock(),

                    ...section.beta,

                    variant: section.beta.variant || 'beta',

                    external: true,

                  }}

                  onChange={(nextBtn) => update({

                    beta: {

                      ...section.beta,

                      text: nextBtn.text ?? section.beta.text,

                      href: nextBtn.href ?? section.beta.href,

                      icon: nextBtn.icon,

                      variant: nextBtn.variant,

                      style: nextBtn.style,

                    },

                  })}

                />

              </>

            )}

          </div>

        </OptionGroup>

      )}



      {section.type === 'faq' && (

        <>

          {(section.items || []).map((item, fIdx) => (

            <SortableItem key={fIdx} listId="faq" index={fIdx} className="tpb-nested-block" onMove={(from, to) => update({ items: reorder(section.items, from, to) })}>

              <div className="tpb-nested-block-head">

                <DragHandle listId="faq" index={fIdx} />

                <strong>{item.question || `FAQ ${fIdx + 1}`}</strong>

                {(section.items || []).length > 1 && (

                  <button

                    type="button"

                    className="admin-icon-btn danger"

                    title="Remove FAQ item"

                    onClick={() => update({ items: section.items.filter((_, i) => i !== fIdx) })}

                  >

                    <i className="fas fa-trash" aria-hidden="true" />

                  </button>

                )}

              </div>

              <label>

                Question

                <input

                  value={item.question || ''}

                  onChange={(e) => {

                    const items = [...section.items];

                    items[fIdx] = { ...item, question: e.target.value };

                    update({ items });

                  }}

                />

              </label>

              <label className="admin-checkbox">

                <input

                  type="checkbox"

                  checked={!!item.isList}

                  onChange={(e) => {

                    const items = [...section.items];

                    items[fIdx] = {

                      ...item,

                      isList: e.target.checked,

                      listItems: e.target.checked ? (item.listItems?.length ? item.listItems : ['']) : [],

                      answer: e.target.checked ? '' : (item.answer || ''),

                    };

                    update({ items });

                  }}

                />

                Answer is a bullet list

              </label>

              {item.isList ? (

                <RichTextParagraphsField

                  label="List items (one per paragraph)"

                  paragraphs={item.listItems || []}

                  rows={4}

                  onChange={(listItems) => {

                    const items = [...section.items];

                    items[fIdx] = { ...item, listItems };

                    update({ items });

                  }}

                />

              ) : (

                <RichTextField

                  label="Answer"

                  value={item.answer || ''}

                  rows={3}

                  onChange={(answer) => {

                    const items = [...section.items];

                    items[fIdx] = { ...item, answer };

                    update({ items });

                  }}

                />

              )}

            </SortableItem>

          ))}

          <button

            type="button"

            className="btn btn-secondary tpb-add-btn"

            onClick={() => update({ items: [...(section.items || []), { question: '', answer: '', isList: false, listItems: [] }] })}

          >

            <i className="fas fa-plus" aria-hidden="true" /> Add FAQ item

          </button>

        </>

      )}



      {section.type === 'importString' && (

        <>

          <RichTextField

            label="Intro"

            value={section.intro || ''}

            rows={2}

            onChange={(intro) => update({ intro })}

          />

          <label>

            Import string

            <textarea rows={4} value={section.importString || ''} onChange={(e) => update({ importString: e.target.value })} placeholder="Paste Streamer.bot import string here" />

          </label>

          <div className="admin-grid-2">

            <label>

              Copied label

              <input value={section.copiedLabel || 'Copied!'} onChange={(e) => update({ copiedLabel: e.target.value })} />

            </label>

            <label>

              Help text

              <input value={section.helpText || ''} onChange={(e) => update({ helpText: e.target.value })} placeholder="Paste into Streamer.bot via Import..." />

            </label>

          </div>

        </>

      )}



      {section.type === 'commands' && (

        <>

          <RichTextField

            label="Intro"

            value={section.intro || ''}

            rows={2}

            onChange={(intro) => update({ intro })}

          />

          <div className="admin-grid-2">

            <label className="admin-checkbox">

              <input type="checkbox" checked={section.collapsible !== false} onChange={(e) => update({ collapsible: e.target.checked })} />

              Collapsible panel

            </label>

            <label className="admin-checkbox">

              <input type="checkbox" checked={section.defaultOpen !== false} onChange={(e) => update({ defaultOpen: e.target.checked })} />

              Open by default

            </label>

          </div>

          <label>

            Panel title

            <input value={section.panelTitle || 'Commands'} onChange={(e) => update({ panelTitle: e.target.value })} placeholder="Commands" />

          </label>

          {(section.commands || []).map((cmd, cIdx) => (

            <SortableItem key={cIdx} listId="commands" index={cIdx} className="tpb-nested-block" onMove={(from, to) => update({ commands: reorder(section.commands, from, to) })}>

              <div className="tpb-nested-block-head">

                <DragHandle listId="commands" index={cIdx} />

                <strong>{cmd.command || `Command ${cIdx + 1}`}</strong>

                <button

                  type="button"

                  className="admin-icon-btn danger"

                  title="Remove command"

                  onClick={() => update({ commands: section.commands.filter((_, i) => i !== cIdx) })}

                >

                  <i className="fas fa-trash" aria-hidden="true" />

                </button>

              </div>

              <div className="admin-grid-2">

                <label>

                  Command

                  <input

                    value={cmd.command || ''}

                    onChange={(e) => {

                      const commands = [...section.commands];

                      commands[cIdx] = { ...cmd, command: e.target.value };

                      update({ commands });

                    }}

                    placeholder="!lurk"

                  />

                </label>

                <label>

                  Permission

                  <input

                    value={cmd.permission || 'EVERYONE'}

                    onChange={(e) => {

                      const commands = [...section.commands];

                      commands[cIdx] = { ...cmd, permission: e.target.value };

                      update({ commands });

                    }}

                    placeholder="EVERYONE"

                  />

                </label>

              </div>

              <label>

                Description

                <textarea

                  rows={2}

                  value={cmd.description || ''}

                  onChange={(e) => {

                    const commands = [...section.commands];

                    commands[cIdx] = { ...cmd, description: e.target.value };

                    update({ commands });

                  }}

                />

              </label>

              <label>

                Example

                <input

                  value={cmd.example || ''}

                  onChange={(e) => {

                    const commands = [...section.commands];

                    commands[cIdx] = { ...cmd, example: e.target.value };

                    update({ commands });

                  }}

                  placeholder="!lurk"

                />

              </label>

            </SortableItem>

          ))}

          <button

            type="button"

            className="btn btn-secondary tpb-add-btn"

            onClick={() => update({

              commands: [...(section.commands || []), { command: '', permission: 'EVERYONE', description: '', example: '' }],

            })}

          >

            <i className="fas fa-plus" aria-hidden="true" /> Add command

          </button>

        </>

      )}

      </OptionGroup>

    </div>

  );

}


